export * from './useNotMinimizedPins';
